import mime from 'mime';

/**
 * Получает MIME тип файла по имени файла
 * @param filename - Имя файла с расширением (например, "presentation.pptx")
 * @returns MIME тип или пустая строка если не удалось определить
 * @example
 * getMimeType('document.pdf') // 'application/pdf'
 * getMimeType('presentation.pptx') // 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
 */
export const getMimeType = (filename: string): string => {
  if (!filename) {
    return '';
  }
  return mime.getType(filename) || '';
};
